import { INITIALISE_STATE, TOGGLE_DRAWER, SET_TITLE } from "../actions/types";
import { COMPANY } from "../settings";

const initialState = {
    drawerOpen: false,
    pageTitle: "LieferApp",
    company: COMPANY,
    updateAvailable: false
};

export default function (state = initialState, action) {
    switch (action.type) {
        case INITIALISE_STATE:
            return state;
        case TOGGLE_DRAWER:
            return { ...state, drawerOpen: action.payload };
        case SET_TITLE:
            return { ...state, pageTitle: action.payload };
        default:
            return state;
    }
}
